<template>
    <h3 v-html="$t('TEXT_CONTACT_US_FORM_HEADER')" ref="formRef"></h3>
    <p><span>＊</span>{{ $t('TEXT_REQUIRED_FIELD') }}</p>

    <div class="p-contact__information">
        <dl>
            <dt><span class="icon"><img src="@/assets/img/ui_parts/svg/attention_icon_contact.svg" alt="！" /></span>{{
                $t('LABEL_PLEASE_CONFIRM') }}</dt>
            <dd>{{ $t('TEXT_CONTACT_US_FORM_1') }}</dd>
        </dl>
    </div>

    <div class="p-contact__form p-contact__form--input c-form-parts">
        <dl v-if="!userStore.isOverseasUser" class="merchant">
            <dt>お名前（姓）<span>＊</span></dt>
            <dd>
                <div class="select-area" :class="{ 'is-error': v$.last_name.$error }">
                    <input type="text" name="last_name" id="input-last-name" v-model="contactUsStore.params.last_name"
                        :disabled="contactUsStore.isLoggedIn"></input>
                </div>
                <p class="error-txt">{{ $t("ERROR_FIELD_REQUIRED") }}</p>
            </dd>
        </dl>
        <dl class="merchant">
            <dt>お名前（名）<span>＊</span></dt>
            <dd>
                <div class="select-area" :class="{ 'is-error': v$.first_name.$error }">
                    <input type="text" name="first_name" id="input-first-name"
                        v-model="contactUsStore.params.first_name" :disabled="contactUsStore.isLoggedIn"></input>
                </div>
                <p class="error-txt">{{ $t("ERROR_FIELD_REQUIRED") }}</p>
            </dd>
        </dl>
        <dl class="merchant">
            <dt>お電話番号<span>＊</span></dt>
            <dd>
                <div class="select-area" :class="{ 'is-error': v$.phone_number.$error }">
                    <input type="text" name="phone_number" id="input-phone-number"
                        v-model="contactUsStore.params.phone_number" :disabled="contactUsStore.isLoggedIn"></input>
                </div>
                <p class="error-txt">{{ $t("ERROR_FIELD_REQUIRED") }}</p>
            </dd>
        </dl>
        <dl class="merchant">
            <dt>Emailアドレス<span>＊</span></dt>
            <dd>
                <div class="select-area" :class="{ 'is-error': v$.email.$error }">
                    <input type="text" name="email" id="input-email" v-model="contactUsStore.params.email"
                        :disabled="contactUsStore.isLoggedIn"></input>
                </div>
                <p class="error-txt">{{ $t("ERROR_FIELD_REQUIRED") }}</p>
            </dd>
        </dl>
        <dl class="category">
            <dt>お問い合わせ区分<span>＊</span></dt>
            <dd>
                <div class="select-area" :class="{ 'is-error': v$.category_id.$error }">
                    <!-- TODO: When there is an error, add "is-error" class to this "ul.select-area" -->
                    <span class="select-box">
                        <select id="select-category" v-model="contactUsStore.params.category_id" name="inquiry_category"
                            @change="updateSelectedCategory" required>
                            <option value="">{{ $t("LABEL_CHOOSE") }}</option>
                            <option v-for="category in contactUsStore.inquiryCategoryList" :value="category.uuid">{{
                                category.name }}</option>
                        </select>
                    </span>
                </div>
                <p class="error-txt">{{ $t('ERROR_PLEASE_SELECT_CATEGORY') }}</p>
            </dd>
        </dl>
        <dl id="custom-field" v-for="(custom_field, index) in contactUsStore.selectedCategory.custom_fields"
            class="merchant">
            <dt>{{ locale == "ja" ? custom_field.label_ja : custom_field.label_en }}<span
                    v-if="custom_field.required">＊</span></dt>
            <dd>
                <div class="select-area"
                    :class="{ 'is-error': contactUsStore.customFieldError && contactUsStore.customFields[index]['content'] == '' && custom_field.required }">
                    <component :is="custom_field.tag" :type="custom_field.type" :name="custom_field.name"
                        :id="custom_field.id" :value="contactUsStore.customFields[index]['content']"
                        @input="contactUsStore.customFields[index]['content'] = $event.target.value"
                        :style="custom_field.style" :class="custom_field.class" :placeholder="custom_field.placeholder">
                    </component>
                </div>
                <p class="error-txt">{{ $t("ERROR_FIELD_REQUIRED") }}</p>
            </dd>
        </dl>
        <dl class="merchant">
            <dt>利用サービス</dt>
            <dd>
                <div class="select-area">
                    <input type="text" name="service" id="input-service" v-model="contactUsStore.params.service_name"
                        placeholder="例：サービス名を入力してください"></input>
                </div>
                <p class="error-txt">{{ $t("ERROR_FIELD_REQUIRED") }}</p>
            </dd>
        </dl>
        <dl class="merchant">
            <dt>決済ID</dt>
            <dd>
                <div class="select-area">
                    <input type="text" name="payment_id" id="input-payment-id"
                        v-model="contactUsStore.params.payment_id" placeholder="例：決済IDを入力してください"></input>
                </div>
                <p class="error-txt">{{ $t("ERROR_FIELD_REQUIRED") }}</p>
            </dd>
        </dl>
        <dl class="details">
            <dt>{{ $t("LABEL_CONTACT_US_CONTENT") }}<span>＊</span></dt>
            <dd>
                <div class="text-area" :class="{ 'is-error': v$.content.$error }">
                    <!-- TODO: When there is an error, add "is-error" class to this "div.text-area" -->
                    <textarea id="text-area-content" v-model="contactUsStore.params.content" name="inquiry_details"
                        cols="50" rows="5" maxlength="1000"
                        :placeholder="$t('LABEL_CONTACT_US_CONTENT_PLACEHOLDER')"></textarea>
                </div>
                <p>※商品内容や返品・配送等、「決済」以外のお問合せにつきましては、各サービスのお問合せフォームからご連絡いただきますよう、お願いいたします。</p>
                <p class="error-txt">{{ $t("LABEL_INSERT_CONTACT_US_CONTENT") }}</p>
            </dd>
        </dl>
    </div>

    <div class="p-contact__btn p-contact__btn--input">
        <div class="c-btn c-btn--contact-confirm"><input id="btn-confirm" v-on:click="confirm" type="submit"
                :value="$t('LABEL_CONFIRM')"></div>
        <div class="c-btn c-btn--contact-back"><button id="btn-clear" v-on:click="clear" type="reset">{{
            $t("LABEL_BUTTON_CLEAR_SEARCH") }}</button></div>
    </div>
</template>

<script setup>
import { onMounted, onBeforeMount, ref } from "vue";
import { useContactUsStore } from "@/stores/contactUsStore";
import { useVuelidate } from '@vuelidate/core';
import { useUserStore } from "@/stores/userStore";
import { useI18n } from "vue-i18n";
import { getContactUsRules } from "@/validations/contactUsValidation";

const { t } = useI18n();
const formRef = ref();
const contactUsStore = useContactUsStore();
const userStore = useUserStore();
const { locale } = useI18n();
const v$ = useVuelidate(getContactUsRules(userStore, t), contactUsStore.params);

onMounted(() => {
    formRef.value.scrollIntoView({ behavior: "smooth", block: "center" });
});

onBeforeMount(async () => {
    await contactUsStore.getInquiryCategories();
});

async function confirm() {
    if (!await v$.value.$validate() || !validateCustomFields()) {
        return false;
    }
    contactUsStore.step = "confirm";
}

function clear() {
    if (userStore.isOverseasUser) {
        contactUsStore.resetFormForLoggedInUser();
    } else {
        contactUsStore.resetForm();
    }

    formRef.value.scrollIntoView({ behavior: "smooth", block: "center" });
}

//Setting value to show in confirm page
async function updateSelectedCategory(event) {
    if (event.target.value == "") {
        contactUsStore.selectedCategory = { custom_fields: [] };
        contactUsStore.customFields = [];
        return;
    }
    const selected = await contactUsStore.inquiryCategoryList.find(
        category => category.uuid == event.target.value
    );

    contactUsStore.selectedCategory = selected;
    contactUsStore.customFields = [];
    if (contactUsStore.selectedCategory.custom_fields) {
        contactUsStore.selectedCategory.custom_fields.forEach((field, index) => {
            contactUsStore.customFields[index] = {
                name: field.name,
                content: '',
                label_ja: field.label_ja,
                label_en: field.label_en,
                required: field.required,
            }
        });
    }

    setTimeout(() => {
        if (contactUsStore.selectedCategory.custom_fields.length > 0) {
            $('#custom-field').stop(true, true).slideDown()
        }
    }, 50)
}

function validateCustomFields() {
    return contactUsStore.customFields.every(field => {
        if (field.required) {
            const result = field.content !== '' && field.content !== null && field.content !== undefined;
            if (!result) {
                contactUsStore.customFieldError = true;
            }
            return result;
        }
        return true;
    });
}
</script>

<style scoped>
#custom-field {
    display: none;
}
</style>